import React, { useState, useRef, useEffect } from 'react';
import Icon from '../../atoms/icon/icon.js';
import { leftArrowIcon } from './img/left_arrow_icon.js';
import { rightArrowIcon } from './img/right_arrow_icon.js';

/* eslint-disable @typescript-eslint/no-empty-function */
const scrollElementTypes = {
    left: "left",
    right: "right"
};
const AdvisorSection = ({ advisorSectionId, advisorSectionTitle, advisorSectionShortDescriptions, advisorSectionContent = [], 
// loading=false,
elementsCount = {}, needScrollOnBrowser = false }) => {
    const { maxElementsCount = null, elementsCountPhone = 2, elementsCountTablet = 4, elementsCountLaptop = 4, elementsCountDesktop = 4 } = elementsCount;
    const [windowInnerWidth, setWindowInnerWidth] = useState(window.innerWidth);
    const [showLeftScrollElement, setShowLeftScrollElement] = useState(true);
    const [showRightScrollElement, setShowRightScrollElement] = useState(true);
    const advisorsContainerRef = useRef(null);
    const advisorsContainerScrollerRef = useRef(null);
    const calcScrollElementContantWidth = (advisorSectionId) => {
        const contentContainer = document.getElementById(`${advisorSectionId}advisorsContainerScroller`);
        if (!contentContainer)
            return;
        const contentContainerChildrenArray = Array.from(contentContainer.children);
        let contentWidth = 0;
        contentContainerChildrenArray.forEach((el) => {
            const style = window.getComputedStyle(el);
            contentWidth += parseFloat(style.marginLeft) + parseFloat(style.width);
        });
        return { contentWidth, contentContainer }; //eslint-disable-line
    };
    const needShowScrollElement = ({ advisorSectionId, setShowLeftScrollElement, setShowRightScrollElement }) => {
        const data = calcScrollElementContantWidth(advisorSectionId);
        if (!data)
            return;
        const { contentWidth } = data;
        const mainScrollContainer = document.getElementById(`${advisorSectionId}advisorsContainer`);
        if (mainScrollContainer) {
            if (contentWidth <= mainScrollContainer.offsetWidth) {
                setShowLeftScrollElement(false);
                setShowRightScrollElement(false);
                return;
            }
            if (mainScrollContainer.scrollLeft === 0 && contentWidth > mainScrollContainer.offsetWidth) {
                setShowLeftScrollElement(false);
                setShowRightScrollElement(true);
                return;
            }
            if (mainScrollContainer.scrollLeft > 0 && contentWidth > mainScrollContainer.offsetWidth) {
                setShowLeftScrollElement(true);
                setShowRightScrollElement(true);
            }
            if (mainScrollContainer.scrollLeft > 0 && contentWidth > mainScrollContainer.offsetWidth
                && mainScrollContainer.scrollLeft + mainScrollContainer.offsetWidth
                    >= mainScrollContainer.scrollWidth) {
                setShowLeftScrollElement(true);
                setShowRightScrollElement(false);
            }
        }
    };
    const handleResize = () => {
        setWindowInnerWidth(window.innerWidth);
        needShowScrollElement({ advisorSectionId, setShowLeftScrollElement, setShowRightScrollElement });
    };
    const handleScroll = () => {
        needShowScrollElement({ advisorSectionId, setShowLeftScrollElement, setShowRightScrollElement });
    };
    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    useEffect(() => {
        calcScrollElementContantWidth(advisorSectionId);
        needShowScrollElement({ advisorSectionId, setShowLeftScrollElement, setShowRightScrollElement });
    }, [advisorsContainerScrollerRef]);
    useEffect(() => {
        if (advisorsContainerRef.current) {
            const advisorsContainer = advisorsContainerRef.current;
            advisorsContainer.addEventListener("scroll", handleScroll);
            return () => {
                advisorsContainer.removeEventListener("scroll", handleScroll);
            };
        }
        return () => { };
    }, [windowInnerWidth, advisorsContainerRef.current]);
    const getElementsCount = (count) => {
        if (maxElementsCount)
            return maxElementsCount;
        return count;
    };
    const renderAdvisors = () => (advisorSectionContent.map((advisor, index) => (React.createElement("div", { key: index, className: "mbw-advisor-container", "data-testid": "mbw-advisor-container", style: {
            "--elementsCountPhone": getElementsCount(elementsCountPhone),
            "--elementsCountTablet": getElementsCount(elementsCountTablet),
            "--elementsCountLaptop": getElementsCount(elementsCountLaptop),
            "--elementsCountDesktop": getElementsCount(elementsCountDesktop)
        } }, advisor))));
    const renderAdvisorSectionShortDescriptions = () => {
        if (!advisorSectionShortDescriptions)
            return null;
        return (React.createElement("div", { className: "mbw-advisor-section-short-descriptions-holder" }, advisorSectionShortDescriptions));
    };
    const onScrollBtnClick = (e) => {
        const scrollContainer = document.getElementById(`${advisorSectionId}advisorsContainer`);
        if (!scrollContainer)
            return;
        if (e.currentTarget.id === scrollElementTypes.left) {
            scrollContainer.scrollTo({ left: scrollContainer.scrollLeft - scrollContainer.clientWidth, behavior: "smooth" });
            return;
        }
        scrollContainer.scrollTo({ left: scrollContainer.scrollLeft + scrollContainer.offsetWidth, behavior: "smooth" });
    };
    const getScrollElementClassName = (type) => {
        let className = `mbw-advisor-section-scroll-${type}-element-container`;
        if (needScrollOnBrowser)
            className = className + " mbw-advisor-section-scroll-element-container-need-scroll-on-browser";
        return className;
    };
    const renderScrollLeftElement = () => {
        if (!showLeftScrollElement)
            return null;
        return (React.createElement("div", { className: getScrollElementClassName(scrollElementTypes.left) },
            React.createElement("button", { id: scrollElementTypes.left, type: "button", className: "mbw-advisor-section-scroll-element-icon-container", onClick: onScrollBtnClick },
                React.createElement(Icon, { className: "mbw-advisor-section-scroll-element-icon", dataTestId: "mbw-advisor-section-scroll-element-icon" }, leftArrowIcon))));
    };
    const renderScrollRightElement = () => {
        if (!showRightScrollElement)
            return null;
        return (React.createElement("div", { className: getScrollElementClassName(scrollElementTypes.right) },
            React.createElement("button", { id: scrollElementTypes.right, type: "button", className: "mbw-advisor-section-scroll-element-icon-container", onClick: onScrollBtnClick },
                React.createElement(Icon, { className: "mbw-advisor-section-scroll-element-icon", dataTestId: "mbw-advisor-section-scroll-element-icon" }, rightArrowIcon))));
    };
    const renderScrollElements = () => (React.createElement(React.Fragment, null,
        renderScrollLeftElement(),
        renderScrollRightElement()));
    const getAdvisorsContainerClassName = () => {
        let className = "mbw-advisors-container";
        if (needScrollOnBrowser)
            className = className + " mbw-advisors-container-need-scroll-on-browser";
        return className;
    };
    const renderAdvisorSectionContent = () => {
        if (advisorSectionContent.length === 0)
            return null;
        return (React.createElement("div", { className: "mbw-section-main-container" },
            renderScrollElements(),
            renderAdvisorSectionShortDescriptions(),
            React.createElement("div", { id: `${advisorSectionId}advisorsContainer`, className: getAdvisorsContainerClassName(), ref: advisorsContainerRef },
                React.createElement("div", { className: "mbw-advisors-container-scroller", id: `${advisorSectionId}advisorsContainerScroller`, ref: advisorsContainerScrollerRef }, renderAdvisors()))));
    };
    const renderAdvisorSectionTitle = () => {
        if (!advisorSectionTitle)
            return null;
        return (React.createElement("div", { className: "mbw-advisor-section-title-container" }, advisorSectionTitle));
    };
    const renderAdvisorSection = () => (React.createElement("div", { className: "mbw-advisor-section-container" },
        renderAdvisorSectionTitle(),
        renderAdvisorSectionContent()));
    return renderAdvisorSection();
};

export { AdvisorSection as default };
//# sourceMappingURL=advisor_section.js.map
